import { render } from "./dashboard.vue?vue&type=template&id=eef8003e&scoped=true&ts=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=eef8003e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef8003e"]])

export default __exports__